// extracted by mini-css-extract-plugin
export default {"IKButton":"IKButton_IKButton__ah4P0","priority":"IKButton_priority__sIvPM"};